import { render, staticRenderFns } from "./BankSlipPayment.vue?vue&type=template&id=0c6ca954&scoped=true&"
import script from "./BankSlipPayment.vue?vue&type=script&lang=ts&"
export * from "./BankSlipPayment.vue?vue&type=script&lang=ts&"
import style0 from "./BankSlipPayment.vue?vue&type=style&index=0&id=0c6ca954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ca954",
  null
  
)

export default component.exports